/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <React.Fragment>
    <path
      fill="currentColor"
      d="M17.5303 9.5303a.75.75 0 0 0-1.0606-1.0606L11 13.9393l-3.4697-3.4696a.75.75 0 0 0-1.0606 1.0606L11 16.0607l6.5303-6.5304Z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M22 10.5597C22 16.7564 17.9354 22.2194 12 24 6.0647 22.2194 2 16.7564 2 10.5597V4.5202a.5748.5748 0 0 1 .5176-.572A17.2434 17.2434 0 0 0 10.6904.9167L12 0l1.3096.9167a17.243 17.243 0 0 0 8.1728 3.0315.5748.5748 0 0 1 .5176.572v6.0395ZM11.5506 2.1455 12 1.831l.4494.3145A18.744 18.744 0 0 0 20.5 5.3386v5.2211c0 5.383-3.4344 10.146-8.5 11.8658-5.0656-1.7198-8.5-6.4828-8.5-11.8658V5.3386a18.7436 18.7436 0 0 0 8.0506-3.193Z"
      clipRule="evenodd"
    />
  </React.Fragment>,
  'Verified'
);
